import { rem } from 'polished';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { FatalAttraction as FA } from '@vpr/tracking';

import { translate } from '@vimeo/i18n-runtime';
import { Card } from '@vimeo/iris/components';
import { Button } from '@vimeo/iris/components';
import { Header, Paragraph, Link } from '@vimeo/iris/typography';
import { buildUpgradePlanUrl } from '@vimeo/picox';

export const UpgradeCard = styled(Card)`
  padding: ${rem('20px')};
  margin-bottom: ${rem('40px')};
  /* Iris issue with the card's box-shadow, forcing for now: */
  box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0.625rem 0px;
  &:after {
    display: none;
  }
`;

interface Props {
  albumUrl: string;
}

export default function ShareUpsellCard({ albumUrl }: Props) {
  return (
    <UpgradeCard>
      <Header size="4">{translate('Custom album')}</Header>
      <Paragraph size="2">
        {translate({
          singular:
            'You’re sharing the {LINK}default view{/LINK}. To share this album with your custom settings, upgrade to Pro.',
          replacements: {
            LINK: (children: ReactNode) => (
              <Link href={albumUrl} target="_blank" key="upsell-link">
                {children}
              </Link>
            ),
          },
        })}
      </Paragraph>
      <a
        href={buildUpgradePlanUrl(
          {
            paywallTrigger: 'showcase_share_upsell_upgrade_button',
            paywallLocation: 'share_album_modal',
            paywallFeature: 'custom_album',
          },
          {
            paywall: '1',
          },
        )}
        target="_blank"
        rel="noreferrer"
      >
        <Button
          size="sm"
          element="span"
          onClick={() =>
            FA.trackClick({
              container: 'share_album_modal',
              component: 'upgrade_link',
              keyword: 'custom_album',
            })
          }
        >
          {translate('Upgrade')}
        </Button>
      </a>
    </UpgradeCard>
  );
}
